import React from 'react';
import ColorsMain from '../../colors/ColorsMain';
import './button.css';

const ButtonHomeTransaction = ({ title, Icon, onClick, className, classNameIcon, loading }) => {
  return (
    <button
      onClick={onClick}
      className={`button-home-transaction text-white hover:text-[#444455] flex items-start gap-2 p-3 rounded-lg transition-all duration-300 ${className} `}
      style={{ '--bg-layout': ColorsMain.bgLayout }}
      disabled={loading} // ✅ Evita clics cuando está en carga
    >
      {loading ? (
        <div className="w-6 h-6 bg-gray-700 rounded-full animate-pulse"></div>
      ) : (
        Icon && (
          <div>
            <Icon className={classNameIcon} />
          </div>
        )
      )}

      <div>
        {loading ? (
          <div className=" flex h-4 w-12 bg-gray-700 rounded animate-pulse"></div>
        ) : (
          <h3>{title}</h3>
        )}
      </div>
    </button>
  );
};

export default ButtonHomeTransaction;
